<template>
  <div class="menuContainer">
    <!-- 学生 -->
    <div v-if="USERMANAGER.isStudent" class="menuContainer-menu">
      <el-menu @select="selectHandler" :default-active="activeIndex" router text-color="#fff">
        <el-menu-item class="cs-nav-home" index="/studentLanding">
          <template slot="title">
            <i class>
              <img src="../assets/nav-home.png">
            </i>
            <span>首页</span>
          </template>
        </el-menu-item>
        <el-menu-item v-if="enableAutonomousEnrolment" index="/autonomousEnrolment">
          <template slot="title">
            <i class>
              <img src="../assets/nav-money.png">
            </i>
            <span>课程报名</span>
          </template>
        </el-menu-item>
        <el-menu-item index="/addCollectFees/autonomousList">
          <template slot="title">
            <i class>
              <img src="../assets/nav-money.png">
            </i>
            <span>账单信息</span>
            <span v-if="studentInProgressWorkflowCount > 0" class="cs-pendingVACount cs-pendingVideoAppointmentCount-total">
              <span>{{studentInProgressWorkflowCount}}</span>
            </span>
          </template>
        </el-menu-item>
        <el-menu-item index="/signCourse">
          <template slot="title">
            <i class>
              <img src="../assets/nav-online-course.png">
            </i>
            <span>我的课程</span>
          </template>
        </el-menu-item>
        <el-menu-item :index="courseIndex">
          <template slot="title">
            <i class>
              <img src="../assets/nav-schedule.png">
            </i>
            <span>登记在校课程</span>
          </template>
        </el-menu-item>
        <el-menu-item index="/videoAppointmentList" v-if="!bypassVideoAppointment">
          <template slot="title">
            <i class=""><img src="../assets/nav-video.png"></i>
            <span>视频预约</span>
          </template>
        </el-menu-item>
        <el-menu-item index="/homeworkManage">
          <i class>
            <img src="../assets/nav-schools.png">
          </i>
          <span slot="title">作业管理</span>
        </el-menu-item>
        <el-menu-item index="/coursewareManagement" v-if="hasCoursewareManagement">
          <i class>
            <img src="../assets/nav-schools.png">
          </i>
          <span slot="title">课件管理</span>
        </el-menu-item>
        <el-menu-item index="/openCourseList">
          <i class>
            <img src="../assets/nav-video.png">
          </i>
          <span slot="title">公开课<span v-if="hasActiveOpenCourse" class="cs-redLabel cs-activeOpenCourse">(正在上课)</span></span>
        </el-menu-item>
        <el-menu-item index="/saServiceList" v-if="isStudyAbroadStudent">
          <i class>
            <img src="../assets/nav-schools.png">
          </i>
          <span slot="title">真留计划项目</span>
        </el-menu-item>
        <el-menu-item index="/studentProfile">
          <i class>
            <img src="../assets/nav-profile.png">
          </i>
          <span slot="title">个人信息</span>
        </el-menu-item>
        <el-menu-item index="" @click="onOpenVideoSite">
          <i class>
            <img src="../assets/nav-video.png">
          </i>
          <span slot="title">视频观看</span>
        </el-menu-item>
        <el-menu-item class="cs-mobile-logout" index="/">
          <i class="fa fa-user-times" aria-hidden="true"></i>
          <span slot="title">登出</span>
        </el-menu-item>
        <!-- <el-menu-item index="/addCollectFees/topUpBalance">
          <i class>
            <img src="../assets/nav-money.png">
          </i>
          <span slot="title">充值余额</span>
        </el-menu-item> -->
      </el-menu>
    </div>

    <!-- 前台 & 财务 -->
    <div v-if="USERMANAGER.isFrontDesk || USERMANAGER.isFinancial || USERMANAGER.isInternationalSales" class="menuContainer-menu">
      <el-menu @select="selectHandler" :default-active="activeIndex" router text-color="#fff">
        <el-submenu index="1">
          <template slot="title">
            <i class>
              <img src="../assets/nav-rate.png">
            </i>
            <span>定价优惠</span>
          </template>
          <el-menu-item index="/admin/bonusPointMechanism">积分机制</el-menu-item>
          <el-menu-item index="/admin/priceManagement">价格管理</el-menu-item>
          <el-menu-item index="/admin/bpeItemManagement">积分兑换物品管理</el-menu-item>
        </el-submenu>
        <el-submenu index="3" v-if="!USERMANAGER.isAssistant && !USERMANAGER.isFinancialAccounting && !USERMANAGER.isFinancialAssistant">
          <template slot="title">
            <i class>
              <img src="../assets/nav-money.png">
            </i>
            <span>添加收费</span>
          </template>
          <el-menu-item index="/addCollectFees/courseEnrollmentFee">课程收费</el-menu-item>
          <el-menu-item v-if="!USERMANAGER.isInternationalSales" index="/addCollectFees/advanceEnrollmentFee">提前招生占位</el-menu-item>
          <el-menu-item index="/addCollectFees/otherCollectFee">其他收费</el-menu-item>
          <el-menu-item index="/addCollectFees/autonomousList">账单信息</el-menu-item>
          <el-menu-item v-if="!USERMANAGER.isInternationalSales" index="/addCollectFees/freeTrialList">试听课信息</el-menu-item>
        </el-submenu>
        <el-submenu index="5" v-if="!USERMANAGER.isInternationalSales">
          <template slot="title">
            <i class>
              <img src="../assets/nav-attendance.png">
            </i>
            <span>签到</span>
          </template>
          <el-menu-item index="/admin/signInManage">签到管理</el-menu-item>
          <el-menu-item v-if="USERMANAGER.isFrontDesk" index="/admin/signInQuery">签到查询</el-menu-item>
        </el-submenu>
        <el-submenu index="6" v-if="USERMANAGER.isExecutiveManager">
          <template slot="title">
            <i class>
              <img src="../assets/nav-schools.png">
            </i>
            <span>学校/学期/课程</span>
          </template>
          <el-menu-item index="/admin/campusList">校区管理</el-menu-item>
          <el-menu-item index="/admin/contractList">合同管理</el-menu-item>
        </el-submenu>
        <!-- <el-menu-item index="/frontDesk/courseApply"
          v-if="!USERMANAGER.isSales && !USERMANAGER.isAssistant && !USERMANAGER.isReceptionist && !USERMANAGER.isExecutiveManager && !USERMANAGER.isFinancialAccounting && !USERMANAGER.isFinancialAssistant">
          <template slot="title">
            <i class>
              <img src="../assets/nav-schedule.png">
            </i>
            <span>课程报名</span>
          </template>
        </el-menu-item> -->
        <el-menu-item index="/frontDesk/priceQuery">
          <template slot="title">
            <i class>
              <img src="../assets/nav-search.png">
            </i>
            <span>价格查询</span>
          </template>
        </el-menu-item>
        <el-submenu index="4" v-if="USERMANAGER.isFrontDesk && !bypassVideoAppointment">
          <template slot="title">
            <i class>
              <img src="../assets/nav-video.png">
            </i>
            <span>视频预约</span>
            <el-tooltip placement="right">
              <template #content>
                <div v-for="item in pendingVideoAppointmentCount" :key="item.CampusId">
                  <span>{{item.CampusName}}: </span>
                  <span>{{item.Count}}</span>
                </div>
              </template>
              <span class="cs-pendingVACount cs-pendingVideoAppointmentCount-total">
                <span> {{pendingVideoAppointmentCountTotal}}</span>
              </span>
            </el-tooltip>
          </template>
          <el-menu-item index="/videoAppointmentList">预约列表</el-menu-item>
          <el-menu-item index="/admin/computerList">电脑列表</el-menu-item>
        </el-submenu>
        <el-submenu index="/admin/studentList" v-if="USERMANAGER.isReceptionist || USERMANAGER.isFinancial || USERMANAGER.isInternationalSales">
          <template slot="title">
            <i class>
              <img src="../assets/nav-students.png">
            </i>
            <span>学生信息</span>
          </template>
          <el-menu-item index="/admin/studentList">学生列表</el-menu-item>
          <el-menu-item v-if="USERMANAGER.isReceptionist" index="/studentSearch">学生名单查询</el-menu-item>
          <el-menu-item v-if="USERMANAGER.isFinancial || USERMANAGER.isInternationalSales" index="/admin/studentVipCourseRecordList">学生VIP课程记录</el-menu-item>
        </el-submenu>
        <el-menu-item index="/admin/studentList" v-else>
          <template slot="title">
            <i class>
              <img src="../assets/nav-students.png">
            </i>
            <span>学生列表</span>
          </template>
        </el-menu-item>
        <el-menu-item index="/admin/speedupCourseSchedule" v-if="USERMANAGER.isSales || USERMANAGER.isReceptionist || USERMANAGER.isAssistant || USERMANAGER.isExecutiveManager">
          <template slot="title">
            <i class>
              <img src="../assets/nav-schedule.png">
            </i>
            <span>课程安排</span>
          </template>
        </el-menu-item>
        <el-menu-item index="/admin/studentCourseSuggestionList" v-if="USERMANAGER.isFrontDesk || USERMANAGER.isFinancialManager">
          <template slot="title">
            <i class>
              <img src="../assets/nav-schedule.png">
            </i>
            <span>课程推荐</span>
          </template>
        </el-menu-item>
        <el-menu-item v-if="USERMANAGER.isExecutiveManager" index="/teacher/emailVideoList">
          <i class>
            <img src="../assets/nav-video.png">
          </i>
          <span slot="title">讲解视频</span>
        </el-menu-item>
        <el-menu-item index="/frontDesk/salesQuery">
          <template slot="title">
            <i class>
              <img src="../assets/nav-search.png">
            </i>
            <div class="cs-menu-label"><span>实时数据搜索</span><span>(时刻更新变化)</span></div>
          </template>
        </el-menu-item>
        <el-menu-item v-if="USERMANAGER.isFinancialManager" index="/admin/accountManage">
          <template slot="title">
            <i class>
              <img src="../assets/nav-accounts.png">
            </i>
            <span>账号管理</span>
          </template>
        </el-menu-item>
        <el-menu-item index="/finance/accountList" v-if="!USERMANAGER.isAssistant && !USERMANAGER.isFinancialAssistant">
          <template slot="title">
            <i class>
              <img src="../assets/nav-bill.png">
            </i>
            <span>个人账目表</span>
          </template>
        </el-menu-item>
        <el-menu-item index="/admin/logList" v-if="!USERMANAGER.isInternationalSales">
          <i class>
            <img src="../assets/nav-history.png">
          </i>
          <span slot="title">历史记录</span>
        </el-menu-item>
        <el-menu-item v-if="USERMANAGER.isFrontDesk" index="/admin/studentDevice">
          <template slot="title">
            <i class>
              <img src="../assets/nav-students.png">
            </i>
            <span slot="title">学生设备管理</span>
          </template>
        </el-menu-item>
        <el-menu-item index="/admin/porfile">
          <i class>
            <img src="../assets/nav-profile.png">
          </i>
          <span slot="title">个人信息</span>
        </el-menu-item>
        <el-menu-item v-if="USERMANAGER.isExecutiveManager || USERMANAGER.isFinancialManager || (USERMANAGER.isFrontDesk && !USERMANAGER.isAssistant) 
            || USERMANAGER.isFinancialAccounting || USERMANAGER.isInternationalSales" index="/admin/performanceEvaluation">
          <i class>
            <img src="../assets/nav-performance.png">
          </i>
          <span slot="title">销售业绩</span>
        </el-menu-item>
        <el-menu-item v-if="hasOrganizationChart" index="/admin/orgChart">
          <template slot="title">
            <i class>
              <img src="../assets/nav-accounts.png">
            </i>
            <span>组织结构图</span>
          </template>
        </el-menu-item>
        <el-menu-item class="cs-mobile-logout" index="/admin">
          <i class="fa fa-user-times" aria-hidden="true"></i>
          <span slot="title">登出</span>
        </el-menu-item>
      </el-menu>
    </div>

    <!-- 管理员 -->
    <div v-if="USERMANAGER.isAdmin" class="menuContainer-menu">
      <el-menu :default-active="activeIndex" router text-color="#fff" @select="selectHandler">
        <el-submenu index="1">
          <template slot="title">
            <i class>
              <img src="../assets/nav-rate.png">
            </i>
            <span>定价优惠</span>
          </template>
          <el-menu-item index="/admin/bonusPointMechanism">积分机制</el-menu-item>
          <el-menu-item index="/admin/priceManagement">价格管理</el-menu-item>
          <el-menu-item index="/finance/discountManage">优惠管理</el-menu-item>
          <el-menu-item index="/admin/bpeItemManagement">积分兑换物品管理</el-menu-item>
        </el-submenu>
        <el-submenu index="2">
          <template slot="title">
            <i class>
              <img src="../assets/nav-rate.png">
            </i>
            <span>真留</span>
          </template>
          <el-menu-item index="/studyAbroad/channelList">渠道管理</el-menu-item>
          <el-menu-item index="/studyAbroad/studentList">真留学员服务列表</el-menu-item>
          <el-menu-item index="/studyAbroad/studentInfoList">真留学生信息列表</el-menu-item>
          <el-menu-item index="/studyAbroad/taskAssignment">真留任务分配</el-menu-item>
          <el-menu-item index="/studyAbroad/salesQuery">真留实时数据搜索</el-menu-item>
          <el-menu-item index="/studyAbroad/runningAccount">真留账目流水</el-menu-item>
          <el-menu-item index="/studyAbroad/accountList">真留财务对账表</el-menu-item>
        </el-submenu>
        <el-submenu index="3">
          <template slot="title">
            <i class>
              <img src="../assets/nav-money.png">
            </i>
            <span>添加收费</span>
          </template>
          <el-menu-item index="/addCollectFees/courseEnrollmentFee">课程收费</el-menu-item>
          <el-menu-item index="/addCollectFees/advanceEnrollmentFee">提前招生占位</el-menu-item>
          <el-menu-item index="/addCollectFees/otherCollectFee">其他收费</el-menu-item>
          <el-menu-item index="/addCollectFees/autonomousList">账单信息</el-menu-item>
          <el-menu-item index="/addCollectFees/freeTrialList">试听课信息</el-menu-item>
        </el-submenu>
        <el-submenu index="4" v-if="!bypassVideoAppointment">
          <template slot="title">
            <i class>
              <img src="../assets/nav-video.png">
            </i>
            <span>视频预约</span>
            <el-tooltip placement="right">
              <template #content>
                <div v-for="item in pendingVideoAppointmentCount" :key="item.CampusId">
                  <span>{{item.CampusName}}: </span>
                  <span>{{item.Count}}</span>
                </div>
              </template>
              <span class="cs-pendingVACount cs-pendingVideoAppointmentCount-total">
                <span> {{pendingVideoAppointmentCountTotal}}</span>
              </span>
            </el-tooltip>
          </template>
          <el-menu-item index="/videoAppointmentList" v-if="!bypassVideoAppointment">预约列表</el-menu-item>
          <el-menu-item index="/admin/computerList">电脑列表</el-menu-item>
        </el-submenu>
        <el-submenu index="5">
          <template slot="title">
            <i class>
              <img src="../assets/nav-attendance.png">
            </i>
            <span>签到</span>
          </template>
          <el-menu-item index="/admin/signInManage">签到管理</el-menu-item>
          <el-menu-item index="/admin/signInQuery">签到查询</el-menu-item>
        </el-submenu>
        <el-submenu index="6">
          <template slot="title">
            <i class>
              <img src="../assets/nav-schools.png">
            </i>
            <span>学校/学期/课程</span>
          </template>
          <el-menu-item index="/admin/universityList">学校管理</el-menu-item>
          <el-menu-item index="/admin/termManagement">学期管理</el-menu-item>
          <el-menu-item index="/admin/speedupCourseList">总课程列表</el-menu-item>
          <el-menu-item index="/admin/campusList">校区管理</el-menu-item>
          <el-menu-item index="/openCourseList">公开课管理</el-menu-item>
          <el-menu-item index="/admin/contractList">合同管理</el-menu-item>
        </el-submenu>
        <el-menu-item index="/frontDesk/courseApply">
          <template slot="title">
            <i class>
              <img src="../assets/nav-schedule.png">
            </i>
            <span>课程报名</span>
          </template>
        </el-menu-item>
        <el-menu-item index="/frontDesk/priceQuery">
          <template slot="title">
            <i class>
              <img src="../assets/nav-search.png">
            </i>
            <span>价格查询</span>
          </template>
        </el-menu-item>
        <el-submenu index="/admin/studentList">
          <template slot="title">
            <i class>
              <img src="../assets/nav-students.png">
            </i>
            <span>学生信息</span>
          </template>
          <el-menu-item index="/admin/studentList">学生列表</el-menu-item>
          <el-menu-item index="/studentSearch">学生名单查询</el-menu-item>
          <el-menu-item index="/admin/studentVipCourseRecordList">学生VIP课程记录</el-menu-item>
        </el-submenu>
        <el-menu-item index="/homeworkManage">
          <i class>
            <img src="../assets/nav-schools.png">
          </i>
          <span slot="title">作业管理</span>
        </el-menu-item>
        <el-menu-item index="/coursewareManagement" v-if="hasCoursewareManagement">
          <i class>
            <img src="../assets/nav-schools.png">
          </i>
          <span slot="title">课件管理</span>
        </el-menu-item>
        <el-menu-item index="/teacher/emailVideoList">
          <i class>
            <img src="../assets/nav-video.png">
          </i>
          <span slot="title">讲解视频</span>
        </el-menu-item>
        <el-menu-item index="/admin/speedupCourseSchedule">
          <template slot="title">
            <i class>
              <img src="../assets/nav-schedule.png">
            </i>
            <span>课程安排</span>
          </template>
        </el-menu-item>
        <el-submenu index="7">
          <template slot="title">
            <i class>
              <img src="../assets/nav-students.png">
            </i>
            <span>校区成绩</span>
          </template>
          <el-menu-item index="/admin/studentScoreCollection">校区成绩搜集</el-menu-item>
          <el-menu-item index="/universityScoreLockList">校区成绩锁定</el-menu-item>
        </el-submenu>
        <el-menu-item index="/admin/studentCourseSuggestionList">
          <template slot="title">
            <i class>
              <img src="../assets/nav-schedule.png">
            </i>
            <span>课程推荐</span>
          </template>
        </el-menu-item>
        <el-menu-item index="/frontDesk/salesQuery">
          <template slot="title">
            <i class>
              <img src="../assets/nav-search.png">
            </i>
            <div class="cs-menu-label"><span>实时数据搜索</span><span>(时刻更新变化)</span></div>
          </template>
        </el-menu-item>

        <el-menu-item index="/admin/accountManage">
          <template slot="title">
            <i class>
              <img src="../assets/nav-accounts.png">
            </i>
            <span>账号管理</span>
          </template>
        </el-menu-item>
        <el-menu-item v-if="hasOrganizationChart" index="/admin/orgChart">
          <template slot="title">
            <i class>
              <img src="../assets/nav-accounts.png">
            </i>
            <span>组织结构图</span>
          </template>
        </el-menu-item>
        <el-menu-item index="/finance/accountList">
          <template slot="title">
            <i class>
              <img src="../assets/nav-bill.png">
            </i>
            <span>账目表</span>
          </template>
        </el-menu-item>

        <el-menu-item index="/admin/logList">
          <i class>
            <img src="../assets/nav-history.png">
          </i>
          <span slot="title">历史记录</span>
        </el-menu-item>
        <el-menu-item index="/admin/porfile">
          <i class>
            <img src="../assets/nav-profile.png">
          </i>
          <span slot="title">个人信息</span>
        </el-menu-item>
        <el-menu-item index="/admin/performanceEvaluation">
          <i class>
            <img src="../assets/nav-performance.png">
          </i>
          <span slot="title">销售业绩</span>
        </el-menu-item>
        <el-menu-item index="/admin/schoolHotList">
          <i class>
            <img src="../assets/nav-news.png">
          </i>
          <span slot="title">校园热点</span>
        </el-menu-item>
        <el-menu-item index="/admin/advertistingList">
          <i class>
            <img src="../assets/nav-ads.png">
          </i>
          <span slot="title">广告管理</span>
        </el-menu-item>
        <el-menu-item index="/admin/studentAdvertisement">
          <template slot="title">
            <i class>
              <img src="../assets/nav-ads.png">
            </i>
            <span slot="title">学生广告管理</span>
          </template>
        </el-menu-item>
        <el-menu-item index="/admin/studentDevice">
          <template slot="title">
            <i class>
              <img src="../assets/nav-students.png">
            </i>
            <span slot="title">学生设备管理</span>
          </template>
        </el-menu-item>
        <el-menu-item index="" @click="onOpenVideoSite">
          <i class>
            <img src="../assets/nav-video.png">
          </i>
          <span slot="title">视频观看</span>
        </el-menu-item>
        <el-menu-item index="/questionnaire/questionnaireList">
          <i class>
            <img src="../assets/nav-schools.png">
          </i>
          <span slot="title">问卷管理</span>
        </el-menu-item>
        <el-menu-item class="cs-mobile-logout" index="/admin">
          <i class="fa fa-user-times" aria-hidden="true"></i>
          <span slot="title">登出</span>
        </el-menu-item>
      </el-menu>
    </div>

    <!-- 教务助理 -->
    <div v-if="USERMANAGER.isEducationalAssistant">
      <el-menu :default-active="activeIndex" router text-color="#fff" @select="selectHandler">
        <el-submenu index="5">
          <template slot="title">
            <i class>
              <img src="../assets/nav-attendance.png">
            </i>
            <span>签到</span>
          </template>
          <el-menu-item index="/admin/signInManage">签到管理</el-menu-item>
          <el-menu-item index="/admin/signInQuery">签到查询</el-menu-item>
        </el-submenu>
        <el-menu-item index="/frontDesk/priceQuery">
          <template slot="title">
            <i class>
              <img src="../assets/nav-search.png">
            </i>
            <span>价格查询</span>
          </template>
        </el-menu-item>
        <el-submenu index="/admin/studentList">
          <template slot="title">
            <i class>
              <img src="../assets/nav-students.png">
            </i>
            <span>学生信息</span>
          </template>
          <el-menu-item index="/admin/studentList">学生列表</el-menu-item>
          <el-menu-item index="/admin/studentVipCourseRecordList">学生VIP课程记录</el-menu-item>
        </el-submenu>
        <el-menu-item index="/homeworkManage">
          <i class>
            <img src="../assets/nav-schools.png">
          </i>
          <span slot="title">作业管理</span>
        </el-menu-item>
        <el-menu-item index="/coursewareManagement" v-if="hasCoursewareManagement">
          <i class>
            <img src="../assets/nav-schools.png">
          </i>
          <span slot="title">课件管理</span>
        </el-menu-item>
        <el-menu-item index="/teacher/emailVideoList">
          <i class>
            <img src="../assets/nav-video.png">
          </i>
          <span slot="title">讲解视频</span>
        </el-menu-item>
        <el-menu-item index="/admin/studentScoreCollection">
          <template slot="title">
            <i class>
              <img src="../assets/nav-students.png">
            </i>
            <span slot="title">校区成绩搜集</span>
          </template>
        </el-menu-item>
        <el-menu-item v-if="hasOrganizationChart" index="/admin/orgChart">
          <template slot="title">
            <i class>
              <img src="../assets/nav-accounts.png">
            </i>
            <span>组织结构图</span>
          </template>
        </el-menu-item>
        <el-menu-item index="/admin/porfile">
          <i class>
            <img src="../assets/nav-profile.png">
          </i>
          <span slot="title">个人信息</span>
        </el-menu-item>
        <el-menu-item class="cs-mobile-logout" index="/admin">
          <i class="fa fa-user-times" aria-hidden="true"></i>
          <span slot="title">登出</span>
        </el-menu-item>
      </el-menu>
    </div>

    <!-- 老师 -->
    <div v-if="USERMANAGER.isTeacher">
      <el-menu @select="selectHandler" :default-active="activeIndex" router text-color="#fff">
        <el-menu-item index="/teacher/activateCourse">
          <template slot="title">
            <i class>
              <img src="../assets/nav-online-course.png">
            </i>
            <span>课程列表</span>
          </template>
        </el-menu-item>
        <el-menu-item index="/teacher/schedule">
          <template slot="title">
            <i class>
              <img src="../assets/nav-schedule.png">
            </i>
            <span>课程安排</span>
          </template>
        </el-menu-item>
        <el-menu-item index="/admin/studentScoreCollection">
          <template slot="title">
            <i class>
              <img src="../assets/nav-students.png">
            </i>
            <span slot="title">校区成绩搜集</span>
          </template>
        </el-menu-item>
        <el-menu-item index="/homeworkManage">
          <i class>
            <img src="../assets/nav-schools.png">
          </i>
          <span slot="title">作业管理</span>
        </el-menu-item>
        <el-menu-item index="/coursewareManagement" v-if="hasCoursewareManagement">
          <i class>
            <img src="../assets/nav-schools.png">
          </i>
          <span slot="title">课件管理</span>
        </el-menu-item>
        <el-menu-item index="/teacher/emailVideoList">
          <i class>
            <img src="../assets/nav-video.png">
          </i>
          <span slot="title">讲解视频</span>
        </el-menu-item>
        <el-menu-item v-if="hasOrganizationChart" index="/admin/orgChart">
          <template slot="title">
            <i class>
              <img src="../assets/nav-accounts.png">
            </i>
            <span>组织结构图</span>
          </template>
        </el-menu-item>
        <el-menu-item index="/admin/porfile">
          <i class>
            <img src="../assets/nav-profile.png">
          </i>
          <span slot="title">个人信息</span>
        </el-menu-item>
        <el-menu-item class="cs-mobile-logout" index="/admin">
          <i class="fa fa-user-times" aria-hidden="true"></i>
          <span slot="title">登出</span>
        </el-menu-item>
      </el-menu>
    </div>

    <!-- 平台编辑 -->
    <div v-if="USERMANAGER.isPlatformEditor">
      <el-menu :default-active="activeIndex" router text-color="#fff" @select="selectHandler">
        <el-menu-item index="/admin/porfile">
          <i class>
            <img src="../assets/nav-profile.png">
          </i>
          <span slot="title">个人信息</span>
        </el-menu-item>
        <el-menu-item index="/admin/schoolHotList">
          <template slot="title">
            <i class>
              <img src="../assets/nav-news.png">
            </i>
            <span>校园热点</span>
          </template>
        </el-menu-item>

        <el-menu-item index="/admin/advertistingList">
          <template slot="title">
            <i class>
              <img src="../assets/nav-ads.png">
            </i>
            <span>广告管理</span>
          </template>
        </el-menu-item>
        <el-menu-item v-if="hasOrganizationChart" index="/admin/orgChart">
          <template slot="title">
            <i class>
              <img src="../assets/nav-accounts.png">
            </i>
            <span>组织结构图</span>
          </template>
        </el-menu-item>
        <el-menu-item class="cs-mobile-logout" index="/admin">
          <i class="fa fa-user-times" aria-hidden="true"></i>
          <span slot="title">登出</span>
        </el-menu-item>
      </el-menu>
    </div>

    <!-- 教务总监 -->
    <div v-if="USERMANAGER.isAcademicDirector">
      <el-menu :default-active="activeIndex" router text-color="#fff" @select="selectHandler">
        <el-submenu index="5">
          <template slot="title">
            <i class>
              <img src="../assets/nav-attendance.png">
            </i>
            <span>签到</span>
          </template>
          <el-menu-item index="/admin/signInManage">签到管理</el-menu-item>
          <el-menu-item index="/admin/signInQuery">签到查询</el-menu-item>
        </el-submenu>
        <el-submenu index="6">
          <template slot="title">
            <i class>
              <img src="../assets/nav-schools.png">
            </i>
            <span>学校/学期/课程</span>
          </template>
          <el-menu-item index="/admin/universityList">学校管理</el-menu-item>
          <el-menu-item index="/admin/termManagement">学期管理</el-menu-item>
          <el-menu-item index="/admin/speedupCourseList">总课程列表</el-menu-item>
          <el-menu-item index="/admin/campusList">校区管理</el-menu-item>
          <el-menu-item index="/openCourseList">公开课管理</el-menu-item>
        </el-submenu>
        <el-menu-item index="/frontDesk/priceQuery">
          <template slot="title">
            <i class>
              <img src="../assets/nav-search.png">
            </i>
            <span>价格查询</span>
          </template>
        </el-menu-item>
        <el-submenu index="/admin/studentList">
          <template slot="title">
            <i class>
              <img src="../assets/nav-students.png">
            </i>
            <span>学生信息</span>
          </template>
          <el-menu-item index="/admin/studentList">学生列表</el-menu-item>
          <el-menu-item index="/admin/studentVipCourseRecordList">学生VIP课程记录</el-menu-item>
        </el-submenu>
        <el-menu-item index="/homeworkManage">
          <i class>
            <img src="../assets/nav-schools.png">
          </i>
          <span slot="title">作业管理</span>
        </el-menu-item>
        <el-menu-item index="/coursewareManagement" v-if="hasCoursewareManagement">
          <i class>
            <img src="../assets/nav-schools.png">
          </i>
          <span slot="title">课件管理</span>
        </el-menu-item>
        <el-menu-item index="/teacher/emailVideoList">
          <i class>
            <img src="../assets/nav-video.png">
          </i>
          <span slot="title">讲解视频</span>
        </el-menu-item>
        <el-menu-item index="/admin/speedupCourseSchedule">
          <template slot="title">
            <i class>
              <img src="../assets/nav-schedule.png">
            </i>
            <span>课程安排</span>
          </template>
        </el-menu-item>
        <el-menu-item index="/frontDesk/salesQuery">
          <template slot="title">
            <i>
              <img src="../assets/nav-search.png">
            </i>
            <div class="cs-menu-label"><span>实时数据搜索</span><span>(时刻更新变化)</span></div>
          </template>
        </el-menu-item>
        <el-submenu index="7">
          <template slot="title">
            <i class>
              <img src="../assets/nav-students.png">
            </i>
            <span>校区成绩</span>
          </template>
          <el-menu-item index="/admin/studentScoreCollection">校区成绩搜集</el-menu-item>
          <el-menu-item index="/universityScoreLockList">校区成绩锁定</el-menu-item>
        </el-submenu>
        <el-menu-item index="/admin/accountManage">
          <template slot="title">
            <i class>
              <img src="../assets/nav-accounts.png">
            </i>
            <span>账号管理</span>
          </template>
        </el-menu-item>
        <el-menu-item v-if="hasOrganizationChart" index="/admin/orgChart">
          <template slot="title">
            <i class>
              <img src="../assets/nav-accounts.png">
            </i>
            <span>组织结构图</span>
          </template>
        </el-menu-item>
        <el-menu-item index="/questionnaire/questionnaireList">
          <i class>
            <img src="../assets/nav-schools.png">
          </i>
          <span slot="title">问卷管理</span>
        </el-menu-item>
        <el-menu-item index="/admin/porfile">
          <i class>
            <img src="../assets/nav-profile.png">
          </i>
          <span slot="title">个人信息</span>
        </el-menu-item>
        <el-menu-item class="cs-mobile-logout" index="/admin">
          <i class="fa fa-user-times" aria-hidden="true"></i>
          <span slot="title">登出</span>
        </el-menu-item>
      </el-menu>
    </div>

    <!-- 人事管理 -->
    <div v-if="USERMANAGER.isPersonnelManagement">
      <el-menu :default-active="activeIndex" router text-color="#fff" @select="selectHandler">
        <el-menu-item index="/admin/signInQuery">
          <template slot="title">
            <i class>
              <img src="../assets/nav-attendance.png">
            </i>
            <span>签到查询</span>
          </template>
        </el-menu-item>
        <el-menu-item index="/studentSearch">
          <template slot="title">
            <i class>
              <img src="../assets/nav-students.png">
            </i>
            <span slot="title">学生名单查询</span>
          </template>
        </el-menu-item>
        <el-menu-item index="/admin/accountManage">
          <template slot="title">
            <i class>
              <img src="../assets/nav-accounts.png">
            </i>
            <span>账号管理</span>
          </template>
        </el-menu-item>
        <el-menu-item v-if="hasOrganizationChart" index="/admin/orgChart">
          <template slot="title">
            <i class>
              <img src="../assets/nav-accounts.png">
            </i>
            <span>组织结构图</span>
          </template>
        </el-menu-item>
        <el-menu-item index="/admin/studentAdvertisement">
          <template slot="title">
            <i class>
              <img src="../assets/nav-ads.png">
            </i>
            <span slot="title">学生广告管理</span>
          </template>
        </el-menu-item>
        <el-menu-item index="/questionnaire/questionnaireList">
          <i class>
            <img src="../assets/nav-schools.png">
          </i>
          <span slot="title">问卷管理</span>
        </el-menu-item>
        <el-menu-item index="/admin/porfile">
          <i class>
            <img src="../assets/nav-profile.png">
          </i>
          <span slot="title">个人信息</span>
        </el-menu-item>
        <el-menu-item class="cs-mobile-logout" index="/admin">
          <i class="fa fa-user-times" aria-hidden="true"></i>
          <span slot="title">登出</span>
        </el-menu-item>
      </el-menu>
    </div>

    <!-- 地区CEO & 校区校长 -->
    <div v-if="USERMANAGER.isRegionCEO || USERMANAGER.isCampusPresident">
      <el-menu :default-active="activeIndex" router text-color="#fff" @select="selectHandler">
        <el-submenu index="1">
          <template slot="title">
            <i>
              <img src="../assets/nav-rate.png">
            </i>
            <span>定价优惠</span>
          </template>
          <el-menu-item index="/admin/bonusPointMechanism">积分机制</el-menu-item>
          <el-menu-item index="/admin/priceManagement">价格管理</el-menu-item>
          <el-menu-item index="/admin/bpeItemManagement">积分兑换物品管理</el-menu-item>
        </el-submenu>
        <el-submenu index="3">
          <template slot="title">
            <i>
              <img src="../assets/nav-money.png">
            </i>
            <span>添加收费</span>
          </template>
          <el-menu-item index="/addCollectFees/courseEnrollmentFee">课程收费</el-menu-item>
          <el-menu-item index="/addCollectFees/advanceEnrollmentFee">提前招生占位</el-menu-item>
          <el-menu-item index="/addCollectFees/otherCollectFee">其他收费</el-menu-item>
          <el-menu-item index="/addCollectFees/autonomousList">账单信息</el-menu-item>
          <el-menu-item index="/addCollectFees/freeTrialList">试听课信息</el-menu-item>
        </el-submenu>
        <el-submenu index="5">
          <template slot="title">
            <i class>
              <img src="../assets/nav-attendance.png">
            </i>
            <span>签到</span>
          </template>
          <el-menu-item index="/admin/signInManage">签到管理</el-menu-item>
          <el-menu-item v-if="USERMANAGER.isCampusPresident" index="/admin/signInQuery">签到查询</el-menu-item>
        </el-submenu>
        <el-submenu index="6">
          <template slot="title">
            <i>
              <img src="../assets/nav-schools.png">
            </i>
            <span>学校/学期/课程</span>
          </template>
          <el-menu-item index="/admin/contractList">合同管理</el-menu-item>
        </el-submenu>
        <el-menu-item index="/frontDesk/priceQuery">
          <template slot="title">
            <i>
              <img src="../assets/nav-search.png">
            </i>
            <span>价格查询</span>
          </template>
        </el-menu-item>
        <el-submenu index="/admin/studentList">
          <template slot="title">
            <i class>
              <img src="../assets/nav-students.png">
            </i>
            <span>学生信息</span>
          </template>
          <el-menu-item index="/admin/studentList">学生列表</el-menu-item>
          <el-menu-item index="/studentSearch">学生名单查询</el-menu-item>
        </el-submenu>
        <el-menu-item index="/homeworkManage">
          <i>
            <img src="../assets/nav-schools.png">
          </i>
          <span slot="title">作业管理</span>
        </el-menu-item>
        <el-menu-item index="/coursewareManagement" v-if="hasCoursewareManagement">
          <i>
            <img src="../assets/nav-schools.png">
          </i>
          <span slot="title">课件管理</span>
        </el-menu-item>
        <el-menu-item index="/admin/speedupCourseSchedule" v-if="USERMANAGER.isRegionCEO">
          <template slot="title">
            <i>
              <img src="../assets/nav-schedule.png">
            </i>
            <span>课程安排</span>
          </template>
        </el-menu-item>
        <el-menu-item index="/admin/studentCourseSuggestionList">
          <template slot="title">
            <i>
              <img src="../assets/nav-schedule.png">
            </i>
            <span>课程推荐</span>
          </template>
        </el-menu-item>
        <el-menu-item index="/frontDesk/salesQuery">
          <template slot="title">
            <i>
              <img src="../assets/nav-search.png">
            </i>
            <div class="cs-menu-label"><span>实时数据搜索</span><span>(时刻更新变化)</span></div>
          </template>
        </el-menu-item>
        <el-menu-item index="/admin/logList" v-if="USERMANAGER.isRegionCEO">
          <i>
            <img src="../assets/nav-history.png">
          </i>
          <span slot="title">历史记录</span>
        </el-menu-item>
        <el-menu-item index="/admin/performanceEvaluation" v-if="USERMANAGER.isRegionCEO">
          <i>
            <img src="../assets/nav-performance.png">
          </i>
          <span slot="title">销售业绩</span>
        </el-menu-item>
        <el-menu-item index="/admin/studentAdvertisement">
          <template slot="title">
            <i>
              <img src="../assets/nav-ads.png">
            </i>
            <span slot="title">学生广告管理</span>
          </template>
        </el-menu-item>
        <el-menu-item v-if="hasOrganizationChart" index="/admin/orgChart">
          <template slot="title">
            <i class>
              <img src="../assets/nav-accounts.png">
            </i>
            <span>组织结构图</span>
          </template>
        </el-menu-item>
        <el-menu-item index="/admin/porfile">
          <i>
            <img src="../assets/nav-profile.png">
          </i>
          <span slot="title">个人信息</span>
        </el-menu-item>
        <el-menu-item class="cs-mobile-logout" index="/admin">
          <i class="fa fa-user-times" aria-hidden="true"></i>
          <span slot="title">登出</span>
        </el-menu-item>
      </el-menu>
    </div>

    <!-- 真留 -->
    <div v-if="USERMANAGER.isStudyAbroad">
      <el-menu :default-active="activeIndex" router text-color="#fff" @select="selectHandler">

        <el-menu-item index="/admin/priceManagement">
          <template slot="title">
            <i class>
              <img src="../assets/nav-rate.png">
            </i>
            <span slot="title">价格管理</span>
          </template>
        </el-menu-item>

        <el-menu-item index="/studyAbroad/channelList">
          <template slot="title">
            <i class>
              <img src="../assets/nav-schools.png">
            </i>
            <span slot="title">渠道管理</span>
          </template>
        </el-menu-item>

        <el-menu-item index="/studyAbroad/studentList">
          <template slot="title">
            <i class>
              <img src="../assets/nav-money.png">
            </i>
            <span slot="title">学员服务列表</span>
          </template>
        </el-menu-item>

        <el-menu-item index="/studyAbroad/studentInfoList">
          <template slot="title">
            <i class>
              <img src="../assets/nav-students.png">
            </i>
            <span slot="title">学生信息列表</span>
          </template>
        </el-menu-item>

        <el-menu-item index="/studyAbroad/taskAssignment">
          <template slot="title">
            <i class>
              <img src="../assets/nav-schedule.png">
            </i>
            <span slot="title">任务分配</span>
          </template>
        </el-menu-item>

        <el-menu-item v-if="!USERMANAGER.isSABusinessAssistant" index="/studyAbroad/salesQuery">
          <template slot="title">
            <i class>
              <img src="../assets/nav-search.png">
            </i>
            <span slot="title">实时数据搜索</span>
          </template>
        </el-menu-item>

        <el-menu-item v-if="!USERMANAGER.isSABusinessAssistant" index="/studyAbroad/runningAccount">
          <template slot="title">
            <i class>
              <img src="../assets/nav-performance.png">
            </i>
            <div class="cs-menu-label"><span>账目流水</span></div>
          </template>
        </el-menu-item>

        <el-menu-item v-if="!USERMANAGER.isSABusinessAssistant" index="/studyAbroad/accountList">
          <template slot="title">
            <i class>
              <img src="../assets/nav-bill.png">
            </i>
            <span>财务对账表</span>
          </template>
        </el-menu-item>

        <el-menu-item v-if="!USERMANAGER.isSAFinancialAssistant" index="/admin/accountManage">
          <template slot="title">
            <i class>
              <img src="../assets/nav-accounts.png">
            </i>
            <span>账号管理</span>
          </template>
        </el-menu-item>

        <el-menu-item index="/admin/porfile">
          <i class>
            <img src="../assets/nav-profile.png">
          </i>
          <span slot="title">个人信息</span>
        </el-menu-item>

        <el-menu-item class="cs-mobile-logout" index="/admin">
          <i class="fa fa-user-times" aria-hidden="true"></i>
          <span slot="title">登出</span>
        </el-menu-item>
      </el-menu>
    </div>

    <!-- 职业培训主管 -->
    <div v-if="USERMANAGER.isVocationalTrainingManager" class="menuContainer-menu">
      <el-menu :default-active="activeIndex" router text-color="#fff" @select="selectHandler">
        <el-menu-item index="/admin/priceManagement">
          <template slot="title">
            <i class>
              <img src="../assets/nav-rate.png">
            </i>
            <span>价格管理</span>
          </template>
        </el-menu-item>
        <el-submenu index="3">
          <template slot="title">
            <i class>
              <img src="../assets/nav-money.png">
            </i>
            <span>添加收费</span>
          </template>
          <el-menu-item index="/addCollectFees/courseEnrollmentFee">课程收费</el-menu-item>
          <el-menu-item index="/addCollectFees/autonomousList">账单信息</el-menu-item>
        </el-submenu>
        <el-submenu index="5">
          <template slot="title">
            <i class>
              <img src="../assets/nav-attendance.png">
            </i>
            <span>签到</span>
          </template>
          <el-menu-item index="/admin/signInManage">签到管理</el-menu-item>
          <el-menu-item index="/admin/signInQuery">签到查询</el-menu-item>
        </el-submenu>
        <el-submenu index="6">
          <template slot="title">
            <i class>
              <img src="../assets/nav-schools.png">
            </i>
            <span>学校/学期/课程</span>
          </template>
          <el-menu-item index="/admin/termManagement">学期管理</el-menu-item>
          <el-menu-item index="/admin/contractList">合同管理</el-menu-item>
        </el-submenu>
        <el-menu-item index="/admin/studentList">
          <template slot="title">
            <i class>
              <img src="../assets/nav-students.png">
            </i>
            <span>学生列表</span>
          </template>
        </el-menu-item>
        <el-menu-item index="/homeworkManage">
          <i class>
            <img src="../assets/nav-schools.png">
          </i>
          <span slot="title">作业管理</span>
        </el-menu-item>
        <el-menu-item index="/coursewareManagement" v-if="hasCoursewareManagement">
          <i class>
            <img src="../assets/nav-schools.png">
          </i>
          <span slot="title">课件管理</span>
        </el-menu-item>
        <el-menu-item index="/admin/speedupCourseSchedule">
          <template slot="title">
            <i class>
              <img src="../assets/nav-schedule.png">
            </i>
            <span>课程安排</span>
          </template>
        </el-menu-item>
        <el-menu-item index="/frontDesk/salesQuery">
          <template slot="title">
            <i class>
              <img src="../assets/nav-search.png">
            </i>
            <div class="cs-menu-label"><span>实时数据搜索</span><span>(时刻更新变化)</span></div>
          </template>
        </el-menu-item>
        <el-menu-item v-if="hasOrganizationChart" index="/admin/orgChart">
          <template slot="title">
            <i class>
              <img src="../assets/nav-accounts.png">
            </i>
            <span>组织结构图</span>
          </template>
        </el-menu-item>
        <el-menu-item index="/finance/accountList">
          <template slot="title">
            <i class>
              <img src="../assets/nav-bill.png">
            </i>
            <span>账目表</span>
          </template>
        </el-menu-item>
        <el-menu-item index="/admin/logList">
          <i class>
            <img src="../assets/nav-history.png">
          </i>
          <span slot="title">历史记录</span>
        </el-menu-item>
        <el-menu-item index="/admin/porfile">
          <i class>
            <img src="../assets/nav-profile.png">
          </i>
          <span slot="title">个人信息</span>
        </el-menu-item>
        <el-menu-item class="cs-mobile-logout" index="/admin">
          <i class="fa fa-user-times" aria-hidden="true"></i>
          <span slot="title">登出</span>
        </el-menu-item>
      </el-menu>
    </div>
    <!-- <footer class="hidden-xs-only">
      <small>
        Powered by
        <br>Speed Up Education Inc.
      </small>
    </footer> -->
  </div>
</template>

<style lang="scss" scoped>
.menuContainer {
  height: 100%;
  overflow: auto;
  min-width: 210px;
  padding-bottom: 102px;

  .menuContainer-menu {
    min-height: 85%;
  }

  .cs-menu-label {
    display: inline-block;
    span {
      display: block;
      line-height: 25px;
    }
  }

  .el-menu {
    border-right: none;

    .el-menu-item {
      &.cs-nav-home {
        img {
          margin-left: 4px;
          width: 18px;
        }
      }
      i {
        display: inline-block;
        vertical-align: top;
        margin-right: 10px;
      }

      &.is-active {
        color: #fff;
      }
      &:focus,
      &:hover {
        background-color: #59c2e6;
      }
    }

    .el-submenu {
      i {
        display: inline-block;
        vertical-align: top;
        margin-right: 10px;
      }
    }
  }

  footer {
    text-align: left;
    margin-left: 22px;
  }

  .cs-mobile-logout {
    display: none;
  }

  .cs-pendingVideoAppointmentCount-total {
    background-color: #ee2900;
  }
}
.cs-activeOpenCourse {
  margin-left: 5px;
}
@media screen and (max-width: 1152px) {
  .menuContainer {
    min-width: 170px;
  }
}
</style>

<script>
import { getStore, setStore, isSafari } from "../config/mUtils";
import global_ from "../core/global";
import { getPendingVideoAppointmentCount } from "../service/videoAppointment.service";
import { getStudentInProgressWorkflowCount } from "../service/enrollmentFee.service";
import {
  checkActiveOpenCourse,
  getGlobalSettingValuesByTypeList,
} from "../service/common.service";
export default {
  data() {
    return {
      hasCoursewareManagement: true,
      campuseType: global_.campuseType,
      pendingVideoAppointmentCount: [],
      activeIndex: "/courseCount",
      courseIndex: "/courseCount",
      bypassVideoAppointment: global_.bypassVideoAppointment,
      hasActiveOpenCourse: false,
      enableAutonomousEnrolment: false,
      hasOrganizationChart: false,
      studentInProgressWorkflowCount: 0,
      isStudyAbroadStudent: false,
    };
  },
  props: {},
  updated() {
    this.updateFocus();
    this.getCourseIndex();
  },
  created() {
    this.getCourseIndex();
    if (
      this.USERMANAGER.isAdmin ||
      this.USERMANAGER.isFrontDesk ||
      this.USERMANAGER.isFinancial
    ) {
      this.loadPendingVideoAppointmentCount();
    }
    if (this.USERMANAGER.isStudent) {
      this.loadStudentInProgressWorkflowCount();
      this.loadActiveOpenCourse();
    } else {
      this.hasActiveOpenCourse = false;
    }
    if (this.USERMANAGER.isPersonnelManagement) {
      this.activeIndex = "/admin/accountManage";
    }

    this.isStudyAbroadStudent = getStore("user_student_isSAStudent") == "1";
    // getEnableAutonomousEnrolmentSetting().then(result => {
    //   if (result && result.success){
    //     this.enableAutonomousEnrolment = result.data;
    //     let enableAutonomousEnrolmentValue = "";
    //     if (result.data){
    //       enableAutonomousEnrolmentValue = "1";
    //     }
    //     setStore("enableAutonomousEnrolment", enableAutonomousEnrolmentValue);
    //   }
    // });

    this.enableAutonomousEnrolment =
      getStore("enableAutonomousEnrolment") == "1";
    this.hasOrganizationChart = getStore("hasOrganizationChart") == "1";
    let typeList = [
      this.GLOBAL.enumGlobalSettingType.EnableAutonomousEnrolment,
      this.GLOBAL.enumGlobalSettingType.HasOrganizationChart,
    ];
    getGlobalSettingValuesByTypeList(typeList).then((result) => {
      if (result && result.success) {
        this.enableAutonomousEnrolment = result.data.EnableAutonomousEnrolment;
        let enableAutonomousEnrolmentValue = "";
        if (this.enableAutonomousEnrolment) {
          enableAutonomousEnrolmentValue = "1";
        }
        setStore("enableAutonomousEnrolment", enableAutonomousEnrolmentValue);

        this.hasOrganizationChart = result.data.HasOrganizationChart;
        let hasOrganizationChartValue = "";
        if (this.hasOrganizationChart) {
          hasOrganizationChartValue = "1";
        }
        setStore("hasOrganizationChart", hasOrganizationChartValue);
      }
    });
  },
  computed: {
    pendingVideoAppointmentCountTotal() {
      return this.pendingVideoAppointmentCount.sum((item) => item.Count);
    },
  },
  methods: {
    reloadActivateCourse(isOnline) {
      window.location.reload();
    },
    loadPendingVideoAppointmentCount() {
      getPendingVideoAppointmentCount().then((result) => {
        if (!!result && result.success) {
          this.pendingVideoAppointmentCount = result.data;
        }
      });
    },
    loadStudentInProgressWorkflowCount() {
      getStudentInProgressWorkflowCount().then((result) => {
        if (!!result && result.success) {
          this.studentInProgressWorkflowCount = result.data;
        }
      });
    },
    loadActiveOpenCourse() {
      checkActiveOpenCourse().then((result) => {
        if (result && result.success) {
          this.hasActiveOpenCourse = result.data;
        }
      });
    },
    selectHandler(index, indexPath) {
      if (index == "/admin" || index == "/") {
        this.logout();
      } else {
        this.$emit("selectMenu");
      }
    },
    logout() {
      window.localStorage.clear();

      if (!this.USERMANAGER.isStudent) {
        window.location.href = "/admin/";
        window.location.reload();
      } else {
        window.location.href = "/";
      }
    },
    updateFocus() {
      let path = this.$route.path;
      let newActiveIndex = path;

      if (!!this.$route.meta && !!this.$route.meta.menuActive)
        newActiveIndex = this.$route.meta.menuActive;

      if (
        path == "/courseCount" ||
        path == "/courseSchedule" ||
        path == "/studentDisable"
      )
        newActiveIndex = this.courseIndex;

      if (
        path == "/finance/accountList" ||
        path == "/finance/aefAccountProfile"
      )
        newActiveIndex = "/finance/accountList";

      this.activeIndex = newActiveIndex;
    },
    getCourseIndex() {
      let studentEnable = getStore("user_student_enable");
      if (studentEnable == "0") {
        //this.courseIndex = "/studentDisable";
        this.courseIndex = "/courseSchedule";
      } else {
        let hasStudentCourseNumber = getStore(
          "user_student_hasStudentCourseNumber"
        );
        if (hasStudentCourseNumber == "1") {
          this.courseIndex = "/courseSchedule";
        } else {
          this.courseIndex = "/courseCount";
        }
      }
      //console.log(this.courseIndex);
    },
    onOpenVideoSite(){
      //let href = "https://cloud.speedupedu.com";
      let href = "https://speedupvideoclient.azurewebsites.net";
      let safari = isSafari();
      if (safari) {
        window.open(href, "_blank");
      } else {
        var link = document.createElement("a");
        link.href = href;
        link.target = "_blank";
        link.click();
        window.setTimeout(() => {
          //释放内存
          window.URL.revokeObjectURL(link.href);
        }, 1000);
      }
    },
  },
  mounted() {
    this.updateFocus();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/navigator.vue